import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Reactable from 'reactable';
import Money from '../../../common/money';
import { t } from '../../../../modules/infra/i18n';

class AmountsTable extends Component {
  renderLargeSingleRow(singleReport) {
    const Tr = Reactable.Tr;
    const Td = Reactable.Td;
    const { showGiftCards } = this.props;
    return (
      <Tr key={`large_${singleReport.barberName}`}>
        <Td
          column={t('reports:barber_filter.barbers')}
          data={singleReport.barberName}
          className="u-text-left u-pl--"
        >
          {singleReport.barberName}
        </Td>
        <Td
          column="PaidViaSquireAmount"
          value={singleReport.paidViaSquireAmount}
        >
          <Money cents={singleReport.paidViaSquireAmount} />
        </Td>
        <Td
          column="PaidInShopViaPosAmount"
          value={singleReport.paidInShopViaPosAmount}
        >
          <Money cents={singleReport.paidInShopViaPosAmount} />
        </Td>
        <Td
          column="PaidInShopOtherAmount"
          value={singleReport.paidInShopOtherAmount}
        >
          <Money cents={singleReport.paidInShopOtherAmount} />
        </Td>
        <Td
          className={!showGiftCards ? 'is-hidden' : ''}
          column="PaidViaGiftCardAmount"
          value={singleReport.paidViaGiftCardAmount}
        >
          <Money cents={singleReport.paidViaGiftCardAmount} />
        </Td>
        <Td
          column={t('common:total')}
          value={singleReport.total}
        >
          <Money cents={singleReport.total} />
        </Td>
      </Tr>
    );
  }

  renderSmallSingleRow(singleReport) {
    const Tr = Reactable.Tr;
    const Td = Reactable.Td;
    return (
      <Tr key={`small_${singleReport.barberName}`}>
        <Td
          column={t('reports:barber_filter.barbers')}
          data={singleReport.barberName}
          className="u-text-left u-pl--"
        >
          {singleReport.barberName}
        </Td>
        <Td
          column={t('common:total')}
          value={singleReport.total}
        >
          <Money cents={singleReport.total} />
        </Td>
      </Tr>
    );
  }

  render() {
    const { barberReports, summary, showGiftCards } = this.props;

    const sortableSmall = [
      t('reports:barber_filter.barbers'),
      t('common:total'),
    ];
    const sortableLarge = sortableSmall.concat([
      'PaidViaSquireAmount',
      'PaidInShopViaPosAmount',
      'PaidInShopOtherAmount',
      'PaidViaGiftCardAmount',
    ]);

    const Table = Reactable.Table;
    const Thead = Reactable.Thead;
    const Th = Reactable.Th;
    const Tfoot = Reactable.Tfoot;

    let report = null;
    let smallReport = null;

    if (barberReports.length) {
      report = barberReports.map(barberReport => this.renderLargeSingleRow(barberReport));
      smallReport = barberReports.map(barberReport => this.renderSmallSingleRow(barberReport));
    }

    return (
      <div className="u-mt+">
        <Table
          className="c-table-new c-table--small c-table--border c-no-hover table-visible-for-extra-extralarge-and-down"
          sortable={sortableSmall}
        >
          <Thead>
          <Th column={t('reports:barber_filter.barbers')}>
            <span className="barber-header">{t('reports:barber_filter.barbers')}</span>
          </Th>
          <Th
            column={t('common:total')}
            title="Total barber income paid in shop and via Squire"
          >
            <span className="total-header">{t('common:total')}</span>
          </Th>
          </Thead>
          {smallReport}
        </Table>
        <Table
          className="c-table-new c-table--small c-table--border c-no-hover table-visible-for-extra-extralarge-and-up"
          id="table"
          sortable={sortableLarge}
        >
          <Thead>
            <Th column={t('reports:barber_filter.barbers')}>
              <span className="barber-header">{t('reports:barber_filter.barbers')}</span>
            </Th>
            <Th column="PaidViaSquireAmount" title="Amount paid via Squire">
              <span className="paid-via-squire-header">{t('reports:product_sales_report.squire_sales')}</span>
            </Th>
            <Th column="PaidInShopViaPosAmount" title="Amount paid in the shop via POS">
              <span className="paid-in-shop-pos-header">{t('reports:product_sales_report.in_shop_pos_sales')}</span>
            </Th>
            <Th column="PaidInShopOtherAmount" title="Amount paid in the shop by cash or other">
              <span className="paid-in-shop-other-header">{t('reports:product_sales_report.in_shop_cash_sales')}</span>
            </Th>
            <Th column="PaidViaGiftCardAmount" title="Amount paid via gift cards" className={!showGiftCards ? 'is-hidden' : ''}>
              <span className="paid-in-shop-other-header">{t('reports:product_sales_report.gift_card_sales')}</span>
            </Th>
            <Th
              column={t('common:total')}
              title="Total barber income paid in shop and via Squire"
            >
              <span className="total-header">{t('common:total')}</span>
            </Th>
          </Thead>
          {report}
          <Tfoot>
            <tr className="u-type--bold">
              <td className="u-text-left u-pl--">
                {t('common:total')}
              </td>
              <td>
                <Money cents={summary.paidViaSquireAmount} />
              </td>
              <td>
                <Money cents={summary.paidInShopViaPosAmount} />
              </td>
              <td>
                <Money cents={summary.paidInShopOtherAmount} />
              </td>
              <td display-if={showGiftCards}>
                <Money cents={summary.paidViaGiftCardAmount} />
              </td>
              <td>
                <Money cents={summary.totalAmount} />
              </td>
            </tr>
          </Tfoot>
        </Table>
      </div>
    );
  }
}

AmountsTable.propTypes = {
  barberReports: PropTypes.array.isRequired,
  summary: PropTypes.object.isRequired,
  showGiftCards: PropTypes.bool.isRequired,
};

export default AmountsTable;

